import { createRoutine, promisifyRoutine } from 'redux-saga-routines';

import { UPDATE_CURRENT_USER } from 'types/user';

export const updateCurrentUserRoutine = createRoutine(UPDATE_CURRENT_USER);
export const updateCurrentUserHandler = promisifyRoutine(updateCurrentUserRoutine);
